import React from 'react';
import PropTypes from 'prop-types';

const ArrowDownIcon = ({ color = '#C70000', width = 7, height = 14 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" fill="none">
        <path d="M10 8.5L6.29545 12.1745C6.0767 12.3915 5.78835 12.5 5.5 12.5M1 8.5L4.70455 12.1745C4.9233 12.3915 5.21165 12.5 5.5 12.5M5.5 12.5V1.5" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    
);

ArrowDownIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default ArrowDownIcon; 